import React from "react"
import { Nav, TabContainer } from "react-bootstrap"
import { Link, withRouter } from "react-router-dom"
import { RouteComponentProps } from "react-router"
import { ConsortiumPersonnelRoute, ConsortiumsRoute, RandomsPersonnelRoute, RandomsRoute } from "../../config/Routes"

interface RandomNavProps extends RouteComponentProps {
  canManagePools?: boolean
  canManagePersonnel?: boolean
  canManageConsortiumPools?: boolean
  isConsortium: boolean
}

const RandomLink = (props: {name: string, path: string, current: boolean}) => <Link className={`btn btn-sm ${props.current ? "btn-primary" : ""}`} to={{ pathname: props.path }}>{props.name}</Link>

export class RandomNav extends React.PureComponent<RandomNavProps> {
  render() {
    const props = this.props as RouteComponentProps
    const path = props.location.pathname
    return (
      <TabContainer defaultActiveKey={path}>
        {!this.props.isConsortium && <Nav variant="pills" className="m-3">
          { this.props.canManagePools && <Nav.Item><RandomLink path={RandomsRoute} name="Pools" current={path === RandomsRoute} /></Nav.Item> }
          { this.props.canManagePersonnel && <Nav.Item><RandomLink path={RandomsPersonnelRoute} name="Personnel" current={path === RandomsPersonnelRoute} /></Nav.Item> }
        </Nav>}
        {this.props.isConsortium && <Nav variant="pills" className="m-3">
          { this.props.canManageConsortiumPools && <Nav.Item><RandomLink path={ConsortiumsRoute} name="Consortium Pools" current={path === ConsortiumsRoute} /></Nav.Item> }
          { this.props.canManageConsortiumPools && <Nav.Item><RandomLink path={ConsortiumPersonnelRoute} name="Consortium Personnel" current={path === ConsortiumPersonnelRoute} /></Nav.Item> }
        </Nav>}
      </TabContainer>
    )
  }
}

export default withRouter(RandomNav)
